"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUploadShell = void 0;
var react_1 = __importStar(require("react"));
var bannerContext_1 = require("../../Banners/bannerContext");
var UIContent_1 = require("../../../UIContent");
var mediaFormat = {
    image: 'image/*',
    video: 'video/*',
    pdf: 'application/pdf'
};
var mediaErrorMessage = {
    image: UIContent_1.UIContent.ImageInput.onlyFirstFileConsiderErrMsg,
    video: UIContent_1.UIContent.VideoInput.uploadError,
    pdf: UIContent_1.UIContent.Pdf.uploadError
};
var FileUploadShell = function (_a) {
    var isLoading = _a.isLoading, children = _a.children, disabled = _a.disabled, _b = _a.enableFilesDrop, enableFilesDrop = _b === void 0 ? true : _b, parentSetDragOverActive = _a.setDragOverActive, handleUpload = _a.handleUpload, onChange = _a.onChange, value = _a.value, id = _a.id, multiple = _a.multiple, mediaType = _a.mediaType, height = _a.height, width = _a.width, _c = _a.enableClickUpload, enableClickUpload = _c === void 0 ? true : _c;
    var SET_ALERT_BANNER = (0, bannerContext_1.useBannerContext)().SET_ALERT_BANNER;
    var inputRef = (0, react_1.useRef)();
    if (disabled)
        return react_1.default.createElement("div", { style: { width: '100%', height: '100%' } }, children);
    var fireHandleUpload = function (files) {
        handleUpload({
            files: files,
            callback: function (_a) {
                var successfulUploads = _a.successfulUploads;
                onChange(id, multiple
                    ? __spreadArray(__spreadArray([], successfulUploads, true), (value || []), true) : successfulUploads);
            }
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("input", { type: "file", accept: mediaFormat[mediaType], style: { display: 'none' }, ref: inputRef, onChange: function (e) { return fireHandleUpload(e.target.files); }, multiple: multiple }),
        react_1.default.createElement("div", __assign({}, (isLoading
            ? {}
            : {
                onDragEnter: function (e) {
                    e.preventDefault();
                    parentSetDragOverActive(true);
                },
                onDragLeave: function (e) {
                    e.preventDefault();
                    parentSetDragOverActive(false);
                },
                onDragOver: enableFilesDrop
                    ? function (e) { return e.preventDefault(); }
                    : function () { },
                onDrop: enableFilesDrop
                    ? function (e) {
                        var _a, _b;
                        e.preventDefault();
                        e.stopPropagation();
                        if ((_a = e.dataTransfer) === null || _a === void 0 ? void 0 : _a.files) {
                            if (!multiple && ((_b = e.dataTransfer) === null || _b === void 0 ? void 0 : _b.files.length) > 1) { //then set alert saying only first image will be attempted to upload
                                SET_ALERT_BANNER(mediaErrorMessage[mediaType], 'red', 3000);
                            }
                            var filesToUpload = multiple
                                ? Array.from(e.dataTransfer.files)
                                : [Array.from(e.dataTransfer.files)[0]];
                            fireHandleUpload(filesToUpload);
                        }
                    }
                    : function () { }
            }), { onClick: function () { return enableClickUpload && inputRef.current.click(); }, style: { height: height || '100%', width: width || '100%' } }), children)));
};
exports.FileUploadShell = FileUploadShell;
